(function(){
if(window.__hmOrthotal)return;window.__hmOrthotal=true;
var fmt=function(c){var n=(c/100).toFixed(2);return (window.Shopify&&Shopify.currency?Shopify.currency.active:'CHF')+' '+n;};
function qa(r,s){return Array.prototype.slice.call(r.querySelectorAll(s));}
function initVideos(){
  var vids=qa(document,'video[data-hmo-video]');if(!vids.length)return;
  var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!('IntersectionObserver' in window)||rm)return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{threshold:.35});
  vids.forEach(function(v){v.controls=false;io.observe(v);});
}
function initProduct(root){
  if(root.__hmo)return;root.__hmo=1;
  var vs;try{vs=JSON.parse(root.querySelector('[data-hmo-variants]').textContent);}catch(e){vs=[];}
  var form=root.querySelector('[data-hmo-form]');if(!form)return;
  var sizes=qa(root,'[data-hmo-size]'),packs=qa(root,'[data-hmo-pack]');
  var msg=root.querySelector('[data-hmo-msg]');
  // galerie
  var track=root.querySelector('[data-hmo-track]'),thumbs=qa(root,'[data-hmo-thumb]');
  function go(i){var sl=track.children;if(!sl.length)return;i=Math.max(0,Math.min(sl.length-1,i));track.scrollTo({left:sl[i].offsetLeft,behavior:'smooth'});}
  function cur(){var w=track.clientWidth||1;return Math.round(track.scrollLeft/w);}
  if(track){
    thumbs.forEach(function(t){t.addEventListener('click',function(){go(+t.getAttribute('data-hmo-thumb'));});});
    var p=root.querySelector('[data-hmo-prev]'),n=root.querySelector('[data-hmo-next]');
    if(p)p.addEventListener('click',function(){go(cur()-1);});if(n)n.addEventListener('click',function(){go(cur()+1);});
    track.addEventListener('scroll',function(){var c=cur();thumbs.forEach(function(t,i){t.setAttribute('aria-current',i===c?'true':'false');});},{passive:true});
  }
  // taille globale -> selects
  var sel=vs.length?vs[0].id:null;
  sizes.forEach(function(b){if(b.getAttribute('aria-pressed')==='true')sel=+b.getAttribute('data-hmo-size');});
  function applySize(id){sel=id;sizes.forEach(function(b){b.setAttribute('aria-pressed',(+b.getAttribute('data-hmo-size')===id)?'true':'false');});
    qa(root,'[data-hmo-unit]').forEach(function(s){s.value=String(id);});}
  sizes.forEach(function(b){b.addEventListener('click',function(){applySize(+b.getAttribute('data-hmo-size'));});});
  packs.forEach(function(p){p.addEventListener('click',function(){packs.forEach(function(x){x.classList.remove('is-sel');var r=x.querySelector('input');if(r)r.checked=false;});p.classList.add('is-sel');var r=p.querySelector('input');if(r)r.checked=true;});});
  function selPack(){return packs.filter(function(p){return p.classList.contains('is-sel');})[0]||packs[0];}
  function add(){
    msg.textContent='';
    var p=selPack(),items={};
    if(p){qa(p,'[data-hmo-unit]').forEach(function(s){items[s.value]=(items[s.value]||0)+1;});}
    else{items[sel]=1;}
    var arr=Object.keys(items).map(function(k){return {id:+k,quantity:items[k]};});
    if(!arr.length){msg.textContent=form.getAttribute('data-missing');return;}
    var btn=root.querySelector('[data-hmo-atc]');btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:arr})})
      .then(function(r){if(!r.ok)throw new Error('x');return r.json();})
      .then(function(){return window.HomyriaCart.afterAdd(function(){if(form.getAttribute('data-after')==='stay'){btn.disabled=false;document.dispatchEvent(new CustomEvent('cart:refresh'));}else{window.location.href='/cart';}}).finally(function(){if(window.HomyriaCart.compact){btn.disabled=false;}})})
      .catch(function(){btn.disabled=false;msg.textContent=form.getAttribute('data-error');});
  }
  form.addEventListener('submit',function(e){e.preventDefault();add();});
  // barre fixe
  var bar=root.querySelector('[data-hmo-sbar]'),main=root.querySelector('[data-hmo-atc]'),bb=root.querySelector('[data-hmo-sbar-btn]');
  if(bar&&main&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){var e=es[0];var below=e.boundingClientRect.top<0;bar.classList.toggle('is-on',!e.isIntersecting&&below);},{threshold:0}).observe(main);
    bb.addEventListener('click',function(){add();});
  }
}
function initReviews(root){
  if(root.__hmo)return;root.__hmo=1;
  var step=+root.getAttribute('data-step')||5;
  var items=qa(root,'[data-hmo-rv]'),shown=Math.min(step,items.length);
  items.forEach(function(it,i){it.hidden=i>=shown;});
  var btn=root.querySelector('[data-hmo-more]'),m=root.querySelector('[data-hmo-more-msg]');
  btn.addEventListener('click',function(){
    if(shown>=items.length){m.textContent=root.getAttribute('data-fail');return;}
    shown=Math.min(items.length,shown+step);items.forEach(function(it,i){it.hidden=i>=shown;});
  });
}
function init(){qa(document,'[data-hmo-product]').forEach(initProduct);qa(document,'[data-hmo-reviews]').forEach(initReviews);initVideos();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
window.addEventListener('pageshow',function(e){if(e.persisted)window.location.reload();});
})();

